import { useMemo } from 'react';
import { GoalsSummaryDTO } from '../types/goalsSummaryDTO';
import { AsyncComponentHookResultBase } from '../../Types/ComponentHookResult';
import { useGoalsSummaryQuery } from '../api/useGoalsSummaryQuery';
import { GoalTypeDTO } from '../types/goalsDTO';

const FAKE_BOOLEANS_MAP = {
  True: 'Yes',
  False: 'No',
};

export interface GoalSummary extends Omit<GoalsSummaryDTO, 'GoalResults' | 'GoalType'> {
  GoalResults: { label: string; value: string }[];
  GoalType: GoalTypeDTO;
}

export const useGoalsSummary = (): AsyncComponentHookResultBase<GoalSummary[] | null> => {
  const queryInfo = useGoalsSummaryQuery();

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const { GoalsSummary } = queryInfo.data;

    return GoalsSummary.map(goal => ({
      ...goal,

      GoalResults: Object.entries(goal.GoalResults || {}).map(([key, value]) => ({
        label: key,
        value: FAKE_BOOLEANS_MAP[value] || value,
      })),
    }));
  }, [queryInfo.data]);

  return {
    ...queryInfo,
    data,
  };
};
